        import React, { useState } from "react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import "./navbar.css";
import ButtonQuote from "../ButtonQuote/ButtonQuote";

export default function Navbar() {
  const navigate = useNavigate();
  const [click, setClick] = useState(false);

  const handleSubmit = () => {
    navigate("/login");
  };

  const handleClick = () => setClick(!click);
  const closeMenu = () => setClick(false);

  return (
    <div className="header">
      <nav className="navbar">
        {/* Logo */}
        <Link to="home" className="logo" onClick={closeMenu}>
          <img src={require(`../../images/pr_logo.png`)} alt="logo" />
        </Link>

        {/* Hamburger Icon */}
        <div className="hamburger" onClick={handleClick}>
          <span className={click ? "bar open" : "bar"}></span>
          <span className={click ? "bar open" : "bar"}></span>
          <span className={click ? "bar open" : "bar"}></span>
        </div>

        {/* Menu */}
        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <Link to="home" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="about" onClick={closeMenu}>
              About
            </Link>         
          </li>
          <li className="nav-item">
            <Link to="product" onClick={closeMenu}>
              Products
            </Link>
          </li>
          <li className="nav-item">
            <Link to="contact" onClick={closeMenu}>
              Contact
            </Link>
          </li>
            {/* <li className="nav-item">
                <button className="btn-login" onClick={handleSubmit}>
                Login
                </button>
            </li> */}
            
            {/* ButtonQuote for mobile */}
          {/* < li className="nav-item quote-mobile">
            <ButtonQuote />
          </li> */}
        </ul>

        {/* ButtonQuote for desktop */}
        {/* <div className="quote-desktop">
          <ButtonQuote />
        </div> */}
      </nav>
    </div>
  );
}